import {useCallback} from "react";
import PropTypes from 'prop-types';
import {Controller, useFormContext} from 'react-hook-form';

import {LoadingButton} from '@mui/lab';
// @mui
import {styled} from '@mui/material/styles';
import {
  Box,
  Card,
  Stack,
  Container, Typography
} from '@mui/material';

import {useTranslate} from 'src/locales';
import {putFile} from "src/services/file/put-api";
import {getSignedUrl} from "src/services/file/get-signed-url-api";

import FofooEditor from 'src/components/fofoo-editor';
import {
  RHFUpload,
} from 'src/components/hook-form';

// ----------------------------------------------------------------------

const LabelStyle = styled(Typography)(({theme}) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
}));


// ----------------------------------------------------------------------

FinalDataForm.propTypes = {
  isEdit: PropTypes.bool,
  currentRecipe: PropTypes.object,
  onSubmit: PropTypes.func
};

export default function FinalDataForm({isEdit, currentRecipe, onSubmit}) {
  const {
    control,
    setValue,
    formState: {isSubmitting}
  } = useFormContext();

  const {t} = useTranslate();


  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        const {signedUrl, getImageUrl} = await getSignedUrl(file);
        await putFile(signedUrl, file);
        const imageData = {
          filename: file.name,
          preview: getImageUrl,
          url: getImageUrl
        };

        setValue(
          'image',
          JSON.parse(JSON.stringify(imageData))
        );
      }
    },
    [setValue]
  );

  return (
    <Container disableGutters id="final-data-form-container">
      <Card sx={{p: 3}}>
        <Stack spacing={3}>
          <div>
            <Typography variant="h5" sx={{mb: 2}}>{t('page.recipe.add.form.summary.description_title')}</Typography>
            <LabelStyle>{t('page.recipe.add.form.summary.short_description')}</LabelStyle>
            <Controller
              name="description"
              control={control}
              render={({field, fieldState}) => (
                <FofooEditor
                  simple
                  name="description"
                  label={t('page.recipe.add.form.summary.short_description')}
                  value={field.value}
                  onChange={field.onChange}
                  error={!!fieldState.error}
                  helperText={fieldState.error ? fieldState.error?.message : ''}
                />
              )}
            />
          </div>
          <div>
            <Typography variant="h5" sx={{mb: 2}}>{t('page.recipe.add.form.summary.image_title')}</Typography>
            <LabelStyle>{t('page.recipe.add.form.summary.image_required')}</LabelStyle>
            <RHFUpload
              showPreview
              name="image"
              maxSize={1024 * 1024 * 16}
              onDrop={handleDrop}
            />
          </div>
        </Stack>
      </Card>
      <Box sx={{display: 'flex', justifyContent: 'right'}}>
        <Box sx={{flexDirection: 'row', width: {xs: '100%', sm: 'auto'}}}>
          <LoadingButton type="submit" variant="contained" size="large" loading={isSubmitting}
                         sx={{mt: 2, textAlign: 'right', width: {xs: '100%', sm: 'auto'}}}>
            {isEdit ? t('page.recipe.add.form.summary.save_recipe') : t('page.recipe.add.form.summary.add_recipe')}
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
}
